import React from 'react'
import { useState } from 'react'
import { ServerRequestProtected } from '../../../utils/ServerDataRequest'
import { enumUtil } from '../../../utils/Enum'
import Loader from '../../shared/Loader/Loader'
import isNull from '../../../utils/NullChecking'
import { use } from 'react'

const UserSearch = ({ users, setmainActivetab, handleSelectUser, userimages }) => {
    const onClickBack = () => {
        if (users.length > 0) {
            setmainActivetab('ChatList')
        } else {
            setmainActivetab('NewChat')
        }
    }
    const [isLoading, setIsLoading] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const API_URL_Messages = enumUtil.controller.Messages
    const [isUserSearch, setIsUserSearch] = useState(false)

    const [usersList, setUserList] = useState([...users])
    const handleSearchUser = (e) => {
        const value = e.target.value.trim();
        setSearchValue(value)
        // If search is empty, reset to original list or show all users
        if (!value) {
            setUserList(users); // Reset to original list
            setIsUserSearch(false)
            return;
        }

        // For local filtering (client-side)
        const searchLower = value.toLowerCase();
        const filteredUsers = usersList.filter(user => {
            const firstNameMatch = user.FirstName?.toLowerCase().includes(searchLower);
            const lastNameMatch = user.LastName?.toLowerCase().includes(searchLower);
            return firstNameMatch || lastNameMatch;
        });

        if (filteredUsers.length === 0) {
            ServerRequestProtected(API_URL_Messages + "/InstantSearch", 'post', {
                TableName: "MESSAGES",
                SearchCriteria: {
                    "Search": value
                }
            }).then((response) => {
                setIsUserSearch(true)
                setUserList(response);
                setIsLoading(false);
            }).catch((error) => {
                setUserList([]);
                setIsLoading(false);
            });
        }
        setUserList(filteredUsers);
        /*
        if (value.length > 2) {
            setIsLoading(true);
            ServerRequestProtected(API_URL_Messages + "/InstantSearch", 'post', {
                TableName: "MESSAGES",
                SearchCriteria: {
                    "Search": value
                }
            }).then((response) => {
                setUserList(response);
                setIsLoading(false);
            }).catch((error) => {
                setUserList([]);
                setIsLoading(false);
                console.error("Search error:", error);
            });
        } else {
            setUserList([]); // Or setUserList(usersList) to show all when query is short
        }
        */
    }
    const getUserImageURL = (ReceiverID) => {
        if (isUserSearch) {
             const userDetails = usersList.find(image => image.ReceiverID + "" === ReceiverID + "");
            if (!isNull(userDetails?.ProfilePictureURL)) {
                return <img src={userDetails?.ProfilePictureURL} alt="" />
            } else {
                let frstletter = userDetails?.FirstName[0]
                let lstletter = userDetails?.LastName[0]
                if (!isNull(frstletter) && !isNull(lstletter)) {
                    return <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14`}>
                        {lstletter + frstletter}
                    </p>
                }
            }
        } else {
            const userImage = userimages.find(image => image.ReceiverID + "" === ReceiverID + "");
            if (!isNull(userImage?.ProfilePictureURL)) {
                return <img src={userImage?.ProfilePictureURL} alt="" />
            } else {
                const userInitials = users.find(item => item.ReceiverID + "" === ReceiverID + "");
                let frstletter = userInitials?.FirstName[0]
                let lstletter = userInitials?.LastName[0]
                if (!isNull(frstletter) && !isNull(lstletter)) {
                    return <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14`}>
                        {lstletter + frstletter}
                    </p>
                }
            }
        }
    }
    return (
        <div className="ar-sart-chat-screen">
            <div className='za-new-conversation-screen view-profile'>
                {isLoading ? <Loader /> : null}
                <div className='d-flex gap-1 align-items-center za-header py-2 px-10'>
                    <span className='icon-box d-flex align-items-center justify-content-center' onClick={onClickBack}><i className='icon-arrow-left2'></i></span>
                    <p className='heading fs-14'>New Conversation</p>
                </div>

                {/* Forward to screen */}
                {/* <div className=''>

      <div className='d-flex gap-1 align-items-center za-header '>
        <span className='icon-box d-flex align-items-center justify-content-center'><i className='icon-arrow-left2'></i></span>
        <p className='heading fs-14'>Forward to</p>
      </div>

    </div> */}
                <div className='za-content px-10'>

                    <div className='mt-10 ' >
                        <div className="input">
                            <input
                                type="text"
                                className="form-control rounded ps-4"
                                name="serarchnewuser"
                                id="serarchnewuser"
                                onChange={handleSearchUser}
                                value={searchValue}
                                placeholder='Search..'
                            />
                            <i className='icon-Clip-path-group position-absolute top-50 translate-middle-y fs-12'></i>
                        </div>

                    </div>


                    {/* <button className='btn btn-orange px-1 text font-m text-white fs-11'> <i className=''></i> Create Group</button> */}

                    <div className='za-cards d-flex flex-column mt-12 hover-scrollbar'>
                        {usersList && usersList.map((item, index) => {
                            return (
                                <div className='za-card d-flex gap-1 align-items-center' onClick={() => handleSelectUser(item)}>
                                    <div className="img-container s-35 circle">
                                        {getUserImageURL(item.ReceiverID)}
                                    </div>
                                    <div className=''>
                                        <p className='heading'>{item.FirstName} {item.LastName}</p>
                                        <p className='text font-m fs-10 ar-light-color '>{item.UserType}</p>
                                    </div>
                                </div>
                            )
                        })}
                        {/* <div className='za-card d-flex gap-1 align-items-center '>
                        <div className="img-container s-35 circle">
                            <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                        </div>
                        <div className=''>
                            <p className='heading'>Alex john</p>
                            <p className='text font-m fs-10 ar-light-color '>Biller</p>
                        </div>
                    </div>
                    <div className='za-card d-flex gap-1 align-items-center'>
                        <div className="img-container s-35 circle">
                            <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                        </div>
                        <div>
                            <p className='heading'>Alex john</p>
                            <p className='text font-m fs-10 ar-light-color'>Biller</p>
                        </div>

                    </div>

                    <div className='za-card d-flex gap-1 align-items-center'>
                        <div className="img-container s-35 circle">
                            <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                        </div>
                        <div>
                            <p className='heading '>Alex john</p>
                            <p className='text font-m fs-10 ar-light-color'>Biller</p>
                        </div>

                    </div>
                    <div className='za-card d-flex gap-1 align-items-center'>
                        <div className="img-container s-35 circle">
                            <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                        </div>
                        <div>
                            <p className='heading'>Alex john</p>
                            <p className='text font-m fs-10 ar-light-color'>Biller</p>
                        </div>

                    </div>
                    <div className='za-card d-flex gap-1 align-items-center'>
                        <div className="img-container s-35 circle">
                            <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                        </div>
                        <div>
                            <p className='heading'>Alex john</p>
                            <p className='text font-m fs-10 ar-light-color'>Biller</p>
                        </div>

                    </div>
                    <div className='za-card d-flex gap-1 align-items-center'>
                        <div className="img-container s-35 circle">
                            <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                        </div>
                        <div>
                            <p className='heading'>Alex john</p>
                            <p className='text font-m fs-10 ar-light-color'>Biller</p>
                        </div>

                    </div>
                    <div className='za-card d-flex gap-1 align-items-center'>
                        <div className="img-container s-35 circle">
                            <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                        </div>
                        <div>
                            <p className='heading'>Bonnie Green</p>
                            <p className='text font-m fs-10 ar-light-color'>Doctor</p>
                        </div>

                    </div>

                    <div className='za-card d-flex gap-1 align-items-center'>
                        <div className="img-container s-35 circle">
                            <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                        </div>
                        <div>
                            <p className='heading'>Clay Axe</p>
                            <p className='text font-m fs-10 ar-light-color'>Biller</p>
                        </div>

                    </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserSearch